var _a;
import { generateSelectors } from "../generators/generator.selectors";
import { GENERATOR_PARAMS, REDUCER_KEY } from "./bankAccount.constants";
import { getContactBankAccountsKey } from "./bankAccount.utils";
export var getDetail = (_a = generateSelectors(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCreatedDetail = _a.getCreatedDetail, isCreating = _a.isCreating, createError = _a.createError, isUpdating = _a.isUpdating, updateError = _a.updateError;
export var isRemovingBankAccountSelector = function (state, id) { var _a, _b, _c; return (id ? (_c = (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.removeBankAccount[id]) === null || _b === void 0 ? void 0 : _b.pending) !== null && _c !== void 0 ? _c : false : false); };
export var removeBankAccountError = function (state, id) { var _a, _b; return (id ? (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.removeBankAccount[id]) === null || _b === void 0 ? void 0 : _b.error : {}); };
export var isUpdatingBankAccountOwnerNameSelector = function (state, id) {
    var _a, _b;
    return id
        ? (_b = (_a = state[REDUCER_KEY].updateBankAccountOwnerName[id]) === null || _a === void 0 ? void 0 : _a.pending) !== null && _b !== void 0 ? _b : false
        : false;
};
export var updateBankAccountOwnerNameError = function (state, id) { var _a; return id ? (_a = state[REDUCER_KEY].updateBankAccountOwnerName[id]) === null || _a === void 0 ? void 0 : _a.error : undefined; };
/**
 * Reads through `?.` on the slice itself, not only on the entry: these selectors
 * run inside shared form schemas, which a store that has not registered this
 * module renders too. Reaching straight into the slice would throw there instead
 * of showing an empty list.
 */
var getContactBankAccountsState = function (state, identifier) {
    var _a;
    var key = getContactBankAccountsKey(identifier);
    if (!key) {
        return;
    }
    return (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.contactBankAccounts[key];
};
export var getContactBankAccounts = function (state, identifier) { var _a; return (_a = getContactBankAccountsState(state, identifier)) === null || _a === void 0 ? void 0 : _a.items; };
export var isFetchingContactBankAccounts = function (state, identifier) { var _a; return ((_a = getContactBankAccountsState(state, identifier)) === null || _a === void 0 ? void 0 : _a.pending) || false; };
export var contactBankAccountsFetchError = function (state, identifier) { var _a; return (_a = getContactBankAccountsState(state, identifier)) === null || _a === void 0 ? void 0 : _a.error; };
export var isCreatingContactBankAccount = function (state) { var _a, _b; return (_b = (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.createContactBankAccount.pending) !== null && _b !== void 0 ? _b : false; };
export var createContactBankAccountError = function (state) { var _a; return (_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.createContactBankAccount.error; };
/**
 * One bank account by id, across every cached contact list. A form summary
 * renders the account the user picked without knowing which contact's list it
 * came from.
 */
export var getContactBankAccount = function (state, bankAccountId) {
    var _a;
    return Object.values(((_a = state[REDUCER_KEY]) === null || _a === void 0 ? void 0 : _a.contactBankAccounts) || {})
        .flatMap(function (_a) {
        var items = _a.items;
        return items || [];
    })
        .find(function (_a) {
        var id = _a.id;
        return id === bankAccountId;
    });
};
